import React, { PropsWithChildren } from 'react';

import { Button } from '@mui/material';

import useStyles from './styles';

interface Props {
    link?: string;
    className?: string;
}

const TopicContent: React.FC<PropsWithChildren<Props>> = ({ link, children, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            {children}
            {link ? (
                <Button
                    disableElevation
                    disableRipple
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    variant="contained"
                    className={classes.link}
                >
                    {'Learn more'}
                </Button>
            ) : null}
        </div>
    );
};
export default TopicContent;
